module.exports = __webpack_public_path__ + "img/iconProjectCompanyAddress.93ca402d.svg";